/* TX announce ticker: Booster's marquee no-ops with one message. One DOM insert at boot, then CSS animation only, so the Judge Me observer is not fed */
(function () {
  'use strict';

  function boot() {
    var bar = document.querySelector('[data-tx-ticker-m], [data-tx-ticker-d]');
    if (!bar || bar.__txTicker) return;
    var tickM = bar.getAttribute('data-tx-ticker-m') === 'true';
    var tickD = bar.getAttribute('data-tx-ticker-d') === 'true';
    if (!tickM && !tickD) return;

    var container = bar.querySelector('.marquee-container');
    var src = container && container.querySelector('p');
    if (!src) return;
    bar.__txTicker = true;

    var msg = src.innerHTML;
    function copyEl(first) {
      var s = document.createElement('span');
      s.className = 'tx-ticker__msg';
      s.innerHTML = msg;
      if (!first) s.setAttribute('aria-hidden', 'true');
      return s;
    }

    var ticker = document.createElement('div');
    ticker.className = 'tx-ticker';
    var track = document.createElement('div');
    track.className = 'tx-ticker__track';
    track.appendChild(copyEl(true));
    ticker.appendChild(track);

    container.style.display = 'none';
    container.parentNode.insertBefore(ticker, container);

    /* two identical halves let the -50% keyframe loop seamlessly */
    var barW = ticker.clientWidth || 390;
    var k = 1;
    while (track.scrollWidth < barW && k < 6) { track.appendChild(copyEl(false)); k++; }
    var half = track.scrollWidth;
    for (var i = 0; i < k; i++) track.appendChild(copyEl(false));

    /* px per second, from the Top bar's Ticker speed setting */
    var speed = parseFloat(bar.getAttribute('data-tx-ticker-speed')) || 15;
    track.style.setProperty('--tx-ticker-dur', Math.max(10, Math.round(half / speed)) + 's');
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
